<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">海外掠影</p>
      <p class="english-name">GLIMPSES</p>
      <div class="swiper-content">
        <a-carousel :dots="false" autoplay ref="swiper">
          <div class="swiper-box" v-for="(item, index) in imgs" :key="index">
            <div>
              <img
                :src="item && item[0] && item[0].fileHttpUrl"
                @click="img = item[0]"
              />
              <p class="pname">{{ item[0].picRemark }}</p>
            </div>
            <div>
              <div class="img-list">
                <img
                  :src="item && item[1] && item[1].fileHttpUrl"
                  @click="img = item[1]"
                />
                <p class="pname">{{ item[1].picRemark }}</p>
              </div>
              <div class="img-list">
                <img
                  :src="item && item[2] && item[2].fileHttpUrl"
                  @click="img = item[2]"
                />
                <p class="pname">{{ item[2].picRemark }}</p>
              </div>
              <div class="img-list">
                <img
                  :src="item && item[3] && item[3].fileHttpUrl"
                  @click="img = item[3]"
                />
                <p class="pname">{{ item[3].picRemark }}</p>
              </div>
              <div class="img-list">
                <img
                  :src="item && item[4] && item[4].fileHttpUrl"
                  @click="img = item[4]"
                />
                <p class="pname">{{ item[4].picRemark }}</p>
              </div>
            </div>
          </div>
        </a-carousel>
        <div class="arrow">
          <p @click="choose(true)">
            <img src="../../../assets/images/icon_carousel_left.png" />
          </p>
          <p @click="choose(false)">
            <img src="../../../assets/images/icon_carousel_right.png" />
          </p>
        </div>
      </div>
    </div>
    <a-modal
      :visible="!!img"
      :footer="null"
      :closable="false"
      width="980px"
      @cancel="img = ''"
      style="background: rgba(0, 0, 0, 0)"
      :maskClosable="false"
    >
      <div style="text-align: center">
        <img width="960px" height="640px" :src="img.fileHttpUrl" alt="" />
      </div>
      <div class="arrow">
        <p @click="change(true)" style="top: 350px">
          <a-icon type="left" style="color: white; font-size: 50px" />
        </p>
        <p @click="change(false)" style="top: 350px">
          <a-icon type="right" style="color: white; font-size: 50px" />
        </p>
      </div>
      <div class="close-tag" @click="img = ''">
        <a-icon type="close" />
      </div>
      <div class="tag">{{ img.picRemark }}</div>
    </a-modal>
  </div>
</template>

<script>
import { getHuntingOverseas } from "@/api/service.js";
import { getFileDetails } from "@/api/file.js";
export default {
  name: "success-case",
  data() {
    return {
      imgs: [],
      img: "",
      remark: [],
      pages: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    imgChose(item) {
      const list = this._.cloneDeep(this.imgs).flat();
      this.img = list[item];
      this.picRemark = item;
    },
    change(isprev) {
      const index = this._.cloneDeep(this.imgs)
        .flat()
        .findIndex((item) => item.fileHttpUrl === this.img.fileHttpUrl);
      const list = this._.cloneDeep(this.imgs).flat();
      if (isprev) {
        this.img = this._.get(list, `${index - 1}`, "");
        if (index <= 0) {
          return;
        }
      } else {
        this.img = this._.get(list, `${index + 1}`, "");
      }
    },
    choose(isprev) {
      if (isprev) {
        if (0 < this.pages <= this.imgs.length - 1 && this.pages != 0) {
          this.pages--;
        } else {
          this.pages = this.imgs.length - 1;
        }
      } else {
        this.$refs && this.$refs.swiper.next();
        if (
          0 < this.pages <= this.imgs.length - 1 &&
          this.pages != this.imgs.length - 1
        ) {
          this.pages++;
        } else {
          this.pages = 0;
        }
      }
    },
    getList() {
      getHuntingOverseas().then((res) => {
        console.log(res, "海外掠影-1");
        this.remark = res.data.contentPicFileDtoList;
        const appCode = this._.get(res, "data.appCode", "");
        const tenantCode = this._.get(res, "data.tenantCode", "");
        const fileCode = this._.get(res, "data.contentPicFileDtoList", []).map(
          (item) => item.fileCode
        );
        getFileDetails(appCode, tenantCode, fileCode).then((res) => {
          //
          console.log(res, "海外掠影-2");
          this.imgs = Object.values(res.data).reduce(
            (acc = [], item, index) => {
              Object.assign(item, { picRemark: this.remark[index].picRemark });
              // item.fileHttpUrl = `http://10.10.152.115/` + item.fileHttpUrl
              if (index === 0) {
                acc[0] = [item];
              } else if ((index + 1) % 6 === 0) {
                acc.push([item]);
              } else {
                acc[acc.length - 1].push(item);
              }
              return acc;
            },
            []
          );
        });
      });
    },
  },
};
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  position: relative;
  margin-top: 20px;
  margin-bottom: 50px;
}
.box {
  width: 1140px;
  height: 480px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
  cursor: pointer;
}
.swiper-content {
  height: 360px;
  width: 1140px;
  position: relative;
  .swiper-box {
    font-size: 0px;
    img:hover {
      transition: 0.3s ease;
      transform: scale(1.1, 1.1);
    }
    > div {
      display: inline-block;
      font-size: 0px;
      vertical-align: middle;
    }
    > div:first-of-type {
      width: 560px;
      height: 360px;
      margin-right: 30px;
      position: relative;
      > img {
        width: 560px;
        height: 360px;
      }
      .left-title {
        position: absolute;
        left: 19px;
        bottom: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        z-index: 2;
      }
    }
    > div:last-of-type {
      width: 549px;
      height: 360px;
      text-align: left;
      .img-list {
        position: relative;
        display: inline-block;
        width: 260px;
        height: 170px;
        img {
          width: 260px;
          height: 170px;
        }
        .right-title {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          position: absolute;
          left: 19px;
          bottom: 9px;
        }
      }
      .img-list:first-of-type,
      .img-list:nth-of-type(2) {
        margin-bottom: 20px;
      }
      .img-list:nth-of-type(2n) {
        margin-left: 29px;
      }
    }
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    width: 20px;
    height: 34px;
    top: 163px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: -40px;
  }
  p:last-of-type {
    right: -36px;
  }
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  position: relative;
}
/deep/ .ant-modal-content {
  background: rgba(0, 0, 0, 0);
  box-shadow: none;
}
/deep/ .ant-modal-mask {
  background: rgba(0, 0, 0, 0.8);
}
.close-tag {
  position: absolute;
  top: 300px;
  right: 100px;
  font-size: 30px;
  color: white;
  top: -80px;
  right: -200px;
  cursor: pointer;
}
.pname {
  position: absolute;
  z-index: 999;
  font-size: 16px;
  color: white;
  bottom: 1px;
  text-align: left;
  width: 100%;
  padding-left: 21px;
}
.tag {
  position: absolute;
  text-align: center;
  font-size: 15px;
  color: #fff;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/home/serviceAbroad/siderContent-03.vue